// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"default":"default","text":"text"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

function symbol(currency, unit) {
  if (currency >= 63) {
    if (currency !== 125) {
      if (currency >= 64) {
        return "₸";
      } else {
        return "KGS";
      }
    } else {
      return "UZS";
    }
  } else if (currency !== 57) {
    if (currency) {
      return "₸";
    } else {
      return "Валюта";
    }
  } else if (unit === "text") {
    return "KZT";
  } else {
    return "₸";
  }
}

function make(className) {
  return function (unitOpt) {
    const unit = unitOpt !== undefined ? unitOpt : "default";
    return function (currencyOpt) {
      const currency = currencyOpt !== undefined ? currencyOpt : /* KZT */57;
      return function (precisionOpt) {
        return function (amount) {
          const money = MelNumeral.format({
                NAME: "Float",
                VAL: amount
              });
          const symbol$1 = symbol(currency, unit);
          const className$1 = Cn.fromList({
                hd: "whitespace-nowrap",
                tl: {
                  hd: Cn.take(className),
                  tl: /* [] */0
                }
              });
          return JsxRuntime.jsx("span", {
                      children: money + (" " + symbol$1),
                      className: className$1
                    });
        };
      };
    };
  };
}

function CurrencyView(Props) {
  return Curry._3(make(Props.className)(Props.unit), Props.currency, Props.precision, Props.amount);
}

const make$1 = CurrencyView;

export {
  tToJs ,
  tFromJs ,
  symbol ,
  make$1 as make,
}
/* MelNumeral Not a pure module */
